import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';

import { useCurrentCountry } from '@lib/hooks';
import { Country } from '@lib/providers/LanguageProvider';

import { Typography, TypographyProps } from 'components/v2';

import { TypographyMessageChannel_Message$key } from './__generated__/TypographyMessageChannel_Message.graphql';

const messages = defineMessages({
  sms: {
    id: 'deprecated.fragments.TypographyMessageChannel.sms',
    defaultMessage: 'SMS',
  },
  email: {
    id: 'deprecated.fragments.TypographyMessageChannel.email',
    defaultMessage: 'Email',
  },
  voice: {
    id: 'deprecated.fragments.TypographyMessageChannel.voice',
    defaultMessage: 'Voice',
  },
  inapp: {
    id: 'deprecated.fragments.TypographyMessageChannel.inapp',
    defaultMessage: 'In-App',
  },
  chat: {
    id: 'deprecated.fragments.TypographyMessageChannel.chat',
    defaultMessage: 'Chat',
  },
  fax: {
    id: 'deprecated.fragments.TypographyMessageChannel.fax',
    defaultMessage: 'Fax',
  },
  whatsapp: {
    id: 'deprecated.fragments.TypographyMessageChannel.whatsapp',
    defaultMessage: 'WhatsApp',
  },
  '%future added value': {
    id: 'deprecated.fragments.TypographyMessageChannel.???',
    defaultMessage: '???',
  },
});

export interface TypographyMessageChannelProps extends Omit<TypographyProps, 'classes'> {
  fragmentRef: TypographyMessageChannel_Message$key;
}

const TypographyMessageChannel: React.FC<TypographyMessageChannelProps> = ({ fragmentRef, ...rest }) => {
  const message = useFragment<TypographyMessageChannel_Message$key>(
    graphql`
      fragment TypographyMessageChannel_Message on Message {
        channel
      }
    `,
    fragmentRef,
  );

  const { formatMessage } = useIntl();
  const country = useCurrentCountry();

  const channel = useMemo(() => {
    const res = message.channel as keyof typeof messages;

    // Hide Whatsapp channel when Localization is set to the United States
    // https://app.clickup.com/t/275azu
    if (country === Country.US && res === 'whatsapp') {
      return;
    }
    return res;
  }, [message.channel, country]);

  return <Typography {...rest}>{channel ? formatMessage(messages[channel]) : '-'}</Typography>;
};

export default TypographyMessageChannel;
